export default {
  DESKTOP: 992,
  TABLET: 768,
  XLPHONE: 450,
  PHONE: 376,
};
